import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DealStatusPickerModule } from './deal-status-picker/deal-status-picker.module';
import { DealAppStatusModule } from './deal-application-status/deal-application-status.module';
import { MatIconModule } from '@angular/material/icon';
import { DealDocumentSmartComponent } from './deal-documents/deal-document-smart/deal-document-smart.component';
import { DealDocumentComponent } from './deal-documents/deal-document/deal-document.component';
import { BytesModule } from 'app/pipes/bytes/bytes.module';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { DealAlertsComponent } from './deal-alerts/deal-alerts.component';
import { AlertModule } from 'app/components/alert/alert.module';
import { AddDocumentButtonComponent } from './deal-documents/add-document-button/add-document-button.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DealsSmartComponent } from './deals-smart/deals-smart.component';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { DealsTableComponent } from './deals-table/deals-table.component';
import { DealComponent } from './deal/deal.component';
import { DealSmartTimelineComponent } from './deal-timeline-smart/deal-timeline-smart.component';
import { MatListModule } from '@angular/material/list';
import { OfferModule } from 'app/offer/offer.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ApprovalModule } from 'app/approval/approval.module';
import { DealSmartComponent } from './deal-smart/deal-smart.component';
import { DealActionsSmartComponent } from './deal-actions-smart/deal-actions-smart.component';
import { DealActionsComponent } from './deal-actions/deal-actions.component';
import { DealOwnerComponent } from './deal-owner/deal-owner.component';
import { DealOwnerSmartComponent } from './deal-owner-smart/deal-owner-smart.component';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { BulkSubmitSmartComponent } from './bulk-submit-smart/bulk-submit-smart.component';
import { BulkSubmitComponent } from './bulk-submit/bulk-submit.component';
import { ReactivateDealDialogComponent } from './reactivate-deal-dialog/reactivate-deal-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PotentialDealsModule } from 'app/potential-deals/potential-deals.module';
import { DealDetailsSmartComponent } from 'ng2-app/deal/deal-details-smart/deal-details-smart.component';
import { DealDetailsComponent } from 'ng2-app/deal/deal-details/deal-details.component';
import { DealLoanStatusComponent } from 'app/deal/deal-loan-status/deal-loan-status.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { OfferOptionModule } from 'ng2-app/offer-option/offer-option.module';
import { DealsOptionsComponent } from './deals-options/deals-options.component';
import { DealDataOverridesDialogModule } from 'ng2-app/deal-data-overrides-dialog/deal-data-overrides-dialog.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { DealStatusDisplayComponent } from 'ng2-app/deal/deal-status-display/deal-status-display.component';

@NgModule({
  declarations: [
    DealDocumentSmartComponent,
    DealDocumentComponent,
    AddDocumentButtonComponent,
    DealAlertsComponent,
    DealsSmartComponent,
    DealsTableComponent,
    DealComponent,
    DealSmartTimelineComponent,
    DealDetailsSmartComponent,
    DealDetailsComponent,
    DealLoanStatusComponent,
    DealSmartComponent,
    DealActionsComponent,
    DealActionsSmartComponent,
    DealOwnerComponent,
    DealOwnerSmartComponent,
    BulkSubmitSmartComponent,
    BulkSubmitComponent,
    ReactivateDealDialogComponent,
    DealsOptionsComponent,
  ],
    imports: [
        CommonModule,
        DealAppStatusModule,
        DealStatusPickerModule,
        DealDataOverridesDialogModule,
        PotentialDealsModule,
        MatIconModule,
        BytesModule,
        MatButtonModule,
        MatDividerModule,
        MatMenuModule,
        AlertModule,
        MatProgressSpinnerModule,
        MatListModule,
        MatTableModule,
        MatTabsModule,
        OfferModule,
        MatTooltipModule,
        ApprovalModule,
        OfferOptionModule,
        FormlyModule,
        ReactiveFormsModule,
        FormlyMaterialModule,
        MatDialogModule,
        MatSortModule,
        MatCheckboxModule,
        MatChipsModule,
        MatExpansionModule,
        DealStatusDisplayComponent,
    ],
    exports: [
        DealsSmartComponent,
        DealsTableComponent,
        DealDocumentComponent,
    ],
})
export class DealModule {}
